import React, { useContext, useEffect, useRef, useState } from "react";
import PrivacyPolicyIcon from "../../SVGComponents/PrivacyPolicyIcon";
import DownArrow from "../../SVGComponents/DownArrow";
import LogoutIcon from "../../SVGComponents/LogoutIcon";
import { Toggle } from "@fluentui/react/lib/Toggle";
import themeContext from "../../../context/theme/ThemeContext";
import { darkTheme, lightTheme } from "../../../constants/Themes";
import { Dropdown, IconButton } from "@fluentui/react";
import ThemeTypes from "./ThemeTypes";
import AboutUsIcon from "../../SVGComponents/AboutUsIcon";
import { logout } from "../../../service/UserService";
import { useNavigate } from "react-router-dom";
import userContext from "../../../context/users/UserContext";
import { AuthRoutes, HEADER_SEPERATOR, MODAL_TYPE } from "../../../constants/Constants";
import NavIcons from "../nav-icons/NavIcons";
import loaderContext from "../../../context/loader/LoaderContext";

const HeaderDropdown = (props) => {
  const { isActiveData } = useContext(userContext);
  const ref = useRef(null);
  const { onClickOutside, setShowHeaderOptions } = props;

  const { theme, themeName, setThemeName, setTheme, getAlterColor } = useContext(themeContext);
  const [showThemeOptions, setShowThemeOptions] = useState(false);
  const { showModal, setShowModal, enableButtonTourPurpose } = useContext(loaderContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const menuContainer = document.querySelector(
        ".ms-ContextualMenu-container"
      );
      const menuItem = event.target.closest(".ms-ContextualMenu-item");
      if (ref.current && !ref.current.contains(event.target) && !menuItem) {
        setShowThemeOptions(false);
        onClickOutside && !enableButtonTourPurpose.showHeader && onClickOutside();
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const changeTheme = (value) => {
    setTheme(darkTheme);
    setThemeName(value);
  };

  const handleAvailableNow = () => {
    setShowModal(() => {
      const newItem = { ...showModal };
      newItem.show = true;
      newItem.type = MODAL_TYPE.AVAILABLE_NOW;
      return newItem;
    });
    onClickOutside();
  };

  const handleShowTheme = () => {
    setShowModal(() => {
      const newItem = { ...showModal };
      newItem.show = true;
      newItem.type = MODAL_TYPE.THEME_PREFERENCE;
      return newItem;
    });
  };

  const handleShowTour = () => {
    setShowModal(() => {
      const newItem = { ...showModal };
      newItem.show = true;
      newItem.type = MODAL_TYPE.TOUR;
      return newItem;
    });
  };

  const menuPropsItems = () => {
    let items = [
      {
        key: "dark-midnight",
        text: "Mid-Night Dark",
        onClick: (ev) => {
          ev.stopPropagation();
          setShowHeaderOptions(true);
          changeTheme("dark-midnight");
        },
      },
      {
        key: "Blue",
        text: "Mid-Night Blue",
        onClick: (ev) => {
          ev.stopPropagation();
          setShowHeaderOptions(true);
          changeTheme("blue-theme");
        },
      },
      {
        key: "dark",
        text: "Dark Dust",
        onClick: (ev) => {
          ev.stopPropagation();
          changeTheme("dark");
        },
      },
    ];
    return items;
  };

  const menuProps = {
    shouldFocusOnMount: true,
    items: menuPropsItems(),
    styles: {
      root: { background: "rgb(100 116 124 / 37%)", minWidth: "50px" },
    },
  };

  const handleLogout = async () => {
    console.log("Logout button clicked");
    await logout();
    window.location.assign("/");
  };

  return (
    <>
      <div ref={ref} className="navbar-header-dropdown" data-tut={"tour-header"}>
        <ul className="theme-ul dropdown-menu-header scrollable-top-menu modal-scroll-annotation">
        {props.firmName != null &&  <li
            style={{ cursor:'text', textDecoration: "none", color: "unset", wordBreak:'break-all',padding:"10px",borderBottom: HEADER_SEPERATOR }}
          >
              <span style={{cursor:'text',wordBreak:'break-all',marginLeft:'0px'}} className="header-top-bar-list-text">
                {props.firmName}
              </span>
            </li>}
          <a
            style={{ textDecoration: "none", color: "unset" }}
            href={AuthRoutes.ACCOUNTANDSETTINGS}
          >
            <li>
              <NavIcons iconName="account-settings" />
              <span className="header-top-bar-list-text">
                Account And Settings
              </span>
            </li>
          </a>

          <a
            style={{ textDecoration: "none",
              color: isActiveData ? "unset" : "grey",
              cursor: isActiveData ? "pointer" : "not-allowed" 
             }}
            onClick={() =>{ 
              // if(isActiveData)
                handleAvailableNow();
            }}
          >
            <li>
              <NavIcons iconName="available-now" />
              <span className="header-top-bar-list-text">Available Now</span>
            </li>
          </a>

          <a style={{ textDecoration: "none", color: "unset" }} href="/about">
            <li>
              <AboutUsIcon themeName={themeName} />
              <span className="header-top-bar-list-text">About</span>
            </li>
          </a>
          <a
            onClick={() => handleShowTour()}
            style={{ textDecoration: "none", color: "unset" }}
          >
           {window.location.pathname.includes(AuthRoutes.STUDYLIST) && <li
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <NavIcons iconName="tour" />
                <span className="header-top-bar-list-text">Tour</span>
              </div>
            </li>}
          </a>
          <a
            onClick={() => handleShowTheme()}
            style={{ textDecoration: "none", color: "unset" }}
          >
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <NavIcons iconName="theme" />
                <span className="header-top-bar-list-text">Themes</span>
              </div>
            </li>
            {showThemeOptions && (
              <div className="theme-types-container">
                <ThemeTypes />
              </div>
            )}
          </a>
          <a
            style={{ textDecoration: "none", color: "unset" }}
            href="/privacy-policy"
            target="_blank"
          >
            <li>
              <PrivacyPolicyIcon themeName={themeName} />
              <span className="header-top-bar-list-text">Privacy Policy</span>
            </li>
          </a>
          <a
            style={{ textDecoration: "none", color: "unset" }}
            onClick={handleLogout}
          >
            <li
              href="/"
              style={{
                borderTop: HEADER_SEPERATOR,
                borderBottom: HEADER_SEPERATOR,
              }}
            >
              <LogoutIcon themeName={themeName} />
              <span className="header-top-bar-list-text">Logout</span>
            </li>
          </a>
        </ul>
        <span style={{color: getAlterColor("#b9b9b9","#595959")}} className="copyright-text">©DeepTek Inc.</span>
      </div>
    </>
  );
};

export default HeaderDropdown;
